import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Form, Col, Row } from 'react-bootstrap';
import Select from 'react-select';
import { COUNTRY_DESTINATION_MAP } from 'Constants/CountryDestinationConstants';

const StaffInfoSection = ({ data, errors, onChange, onClearErrors, options, getReactSelectStyles }) => {
  const { sourceMarkets, seasons, countries, destinations, jobTitles } = options;

  const filteredDestinations = useMemo(() => {
    if (!data.country) return destinations;
    const allowedDestinations = COUNTRY_DESTINATION_MAP[data.country] || [];
    return destinations.filter((dest) => allowedDestinations.includes(dest.label));
  }, [data.country, destinations]);

  return (
    <>
      <h6 className="text-primary mb-3 mt-4">
        <i className="fa fa-briefcase me-2"></i>Staff Information
      </h6>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>
            Staff Source Market <span className="text-danger">*</span>
          </Form.Label>
          <Select
            options={sourceMarkets}
            isSearchable
            isClearable
            styles={getReactSelectStyles(!!errors.staffSourceMarket)}
            onChange={(e) => {
              onChange({ staffSourceMarket: e?.value || '' });
              onClearErrors();
            }}
            value={sourceMarkets.find((x) => x.value === data.staffSourceMarket) || null}
            placeholder="Select source market"
          />
          {errors.staffSourceMarket && (
            <div className="invalid-feedback d-block">
              {errors.staffSourceMarket || 'Staff source market is required'}
            </div>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Source Market Budget <span className="text-danger">*</span>
          </Form.Label>
          <Select
            options={sourceMarkets}
            isSearchable
            isClearable
            styles={getReactSelectStyles(!!errors.staffSourceMarketBudget)}
            onChange={(e) => {
              onChange({ staffSourceMarketBudget: e?.value || '' });
              onClearErrors();
            }}
            value={sourceMarkets.find((x) => x.value === data.staffSourceMarketBudget) || null}
            placeholder="Select budget market"
          />
          {errors.staffSourceMarketBudget && (
            <div className="invalid-feedback d-block">
              {errors.staffSourceMarketBudget || 'Source market budget is required'}
            </div>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Season <span className="text-danger">*</span>
          </Form.Label>
          <Select
            options={seasons}
            isSearchable
            isClearable
            styles={getReactSelectStyles(!!errors.season)}
            onChange={(e) => {
              onChange({ season: e?.value || '' });
              onClearErrors();
            }}
            value={seasons.find((x) => x.value === data.season) || null}
            placeholder="Select season"
          />
          {errors.season && <div className="invalid-feedback d-block">{errors.season || 'Season is required'}</div>}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>
            Country <span className="text-danger">*</span>
          </Form.Label>
          <Select
            options={countries}
            isSearchable
            isClearable
            styles={getReactSelectStyles(!!errors.country)}
            onChange={(e) => {
              onChange({ country: e?.value || '', destination: '' });
              onClearErrors();
            }}
            value={countries.find((x) => x.value === data.country) || null}
            placeholder="Select country"
          />
          {errors.country && <div className="invalid-feedback d-block">{errors.country || 'Country is required'}</div>}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Destination <span className="text-danger">*</span>
          </Form.Label>
          <Select
            options={filteredDestinations}
            isSearchable
            isClearable
            styles={getReactSelectStyles(!!errors.destination)}
            onChange={(e) => {
              onChange({ destination: e?.value || '' });
              onClearErrors();
            }}
            value={filteredDestinations.find((x) => x.value === data.destination) || null}
            placeholder="Select destination"
            isDisabled={!data.country}
          />
          {errors.destination && (
            <div className="invalid-feedback d-block">{errors.destination || 'Destination is required'}</div>
          )}
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>
            Position Job Title <span className="text-danger">*</span>
          </Form.Label>
          <Select
            options={jobTitles}
            isSearchable
            isClearable
            styles={getReactSelectStyles(!!errors.jobTitle)}
            onChange={(e) => {
              onChange({ jobTitle: e?.value || '' });
              onClearErrors();
            }}
            value={jobTitles.find((x) => x.value === data.jobTitle) || null}
            placeholder="Select job title"
          />
          {errors.jobTitle && (
            <div className="invalid-feedback d-block">{errors.jobTitle || 'Job title is required'}</div>
          )}
        </Form.Group>
      </Row>
    </>
  );
};

StaffInfoSection.propTypes = {
  data: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onClearErrors: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  getReactSelectStyles: PropTypes.func.isRequired,
};

export default StaffInfoSection;
